import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  CryptoWalletIcon,
  DashboardIcon,
  HelpIcon,
  InvestmentIcon,
  LogoutIcon,
  MarketplaceIcon,
  MoneyIcon,
  P2pIcon,
  ReportsIcon,
  SettingIcon,
  ToggleIconClose,
  TransactionsIcon,
  WalletIcon,
} from "../../../assets/icons/svgicons";
import Logo from "../../../assets/logos/text-logo-white.svg";
import { ROUTES } from "../../../routes";
import styles from "./Sidebar.module.scss";
import ProfileDropdown from "../Header/ProfileDropdown/ProfileDropdown";
import { IncludesPath } from "../../../utils/utils";
import CoinProfile from "../Modals/CoinProfile/CoinProfile";
import { useSelector } from "react-redux";
import LogoutModal from "../Modals/LogoutModal/LogoutModal";
import Button from "../Button/Button";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUserInfoAction } from "../../../features/user/userSlice";
import { saveUserData } from "../../../features/persist/persistSlice";

const Sidebar = ({ show, handleShow }) => {
  const [showCoinProfile, setShowCoinProfile] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );

  const userInfo = useSelector((state) => state?.persist?.userInfo);
  /** STBL Money in sidebar for all users; country gating is on card pages. */
  const showStblMoneyNav = true;

  const location = useLocation();

 
  const handleSidebarLinkClick = (sidebar, event) => {
    // if (kycStatus !== "APPROVED" && sidebar !== "DASHBOARD") {
    //   event.preventDefault();
    // } else {
    window.scrollTo(0, 0);
    handleShow && handleShow();
    // }
  };


  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserInfoAction()).then((res) => {
      if (res?.status === 200) {
        dispatch(saveUserData(res.data.data));
      }
    });
  }, []);


  // const handleClick = () => {
  //   if (dropdownRef.current && document.body.clientWidth > 767) {
  //     // screen size for in sidebar don't close dropdown
  //     dropdownRef.current.click();
  //   }
  // };
  return (
    <>
      <div
        className={`${styles.overlay} d-xl-none ${show ? styles.active : ""}`}
        onClick={handleShow}
      />
      <aside className={`${styles.sidebar} ${show ? styles.active : ""}`}>
        <Link className={styles.sidebar_logo} to={ROUTES.BUY}>
          <img src={Logo} alt="Logo" />
        </Link>
        <div className={`${styles.sidebar_hide} d-xl-none`}>
          <button onClick={handleShow}>
            <ToggleIconClose />
          </button>
        </div>
        {/* <div className={`${styles.profile} d-md-none`}>
          <ProfileDropdown />
        </div> */}
        {kycStatus === "APPROVED" ? (
          <ul className={styles.sidebar_list}>
            <li>
              {/* <NavLink
                onClick={(e) => handleSidebarLinkClick("DASHBOARD", e)}
                className={IncludesPath(ROUTES.BUY) ? "active" : ""}
                to={ROUTES.BUY}
              >
                <DashboardIcon />
                Dashboard
              </NavLink> */}
              <NavLink
                onClick={handleSidebarLinkClick}
                className={({ isActive }) =>
                  isActive || IncludesPath(ROUTES.DASHBOARD) ? "active" : ""
                }
                to={ROUTES.BUY}
              >
                <DashboardIcon />
                Dashboard
              </NavLink>
            </li>

            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("MARKETPLACE", e)}
                to={ROUTES.MARKETPLACE}
              >
                {/* onClick={handleSidebarLinkClick} */}
                <MarketplaceIcon />
                Marketplace
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("BUYEQUITY", e)}
                to={ROUTES.BUY_EQUITY}
                className={IncludesPath(ROUTES.BUY_EQUITY) ? "active" : ""}
              >
                <MarketplaceIcon />
                Buy Equity
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("WALLETPORTFOLIO", e)}
                to={ROUTES.WALLETPORTFOLIO}
                className={IncludesPath(ROUTES.WALLETPORTFOLIO) ? "active" : ""}
              >
                <WalletIcon />
                Wallet
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("TRANSACTIONS", e)}
                to={ROUTES.TRANSACTIONS_OPENED}
                className={IncludesPath(ROUTES.TRANSACTIONS_OPENED) ? "active" : ""}
              >
                <TransactionsIcon />
                Transactions
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("STBL_MONEY", e)}
                to={ROUTES.STBL_MONEY}
                className={IncludesPath(ROUTES.STBL_MONEY) ? "active" : ""}
              >
                <MoneyIcon />
                STBL Money
              </NavLink>
            </li> */}
            {showStblMoneyNav && (
              <li>
                <NavLink
                  onClick={(e) =>
                    handleSidebarLinkClick("APPLY_CARD || STBL_MONEY", e)
                  }
                  to={ROUTES.APPLY_CARD ? ROUTES.APPLY_CARD : ROUTES.STBL_MONEY}
                  className={
                    IncludesPath(ROUTES.APPLY_CARD) ||
                      IncludesPath(ROUTES.STBL_MONEY)
                      ? "active"
                      : ""
                  }
                >
                  <MoneyIcon />
                  STBL Money
                </NavLink>
              </li>
            )}
            {/* <li> */}
            {/* <NavLink
                onClick={(e) => handleSidebarLinkClick("P2P_ORDERS_LIST", e)}
                to={ROUTES.P2P_ORDERS_LIST}
                className={
                  IncludesPath([ROUTES.P2P_ORDERS_LIST, ROUTES.MY_ORDERS])
                    ? "active"
                    : ""
                }
              // className={({ isActive }) =>
              //   isActive ||
              //   IncludesPath([ROUTES.P2P_ORDERS_LIST, ROUTES.MY_ORDERS])
              //     ? "active"
              //     : ""
              // }
              >
                <P2pIcon />
                P2P
              </NavLink> */}
            {/* <NavLink
                onClick={(e) => handleSidebarLinkClick("P2P_ORDERS_LIST", e)}
                to={ROUTES.P2P_ORDERS_LIST}
                className={({ isActive }) =>
                  isActive || IncludesPath(location.pathname, [ROUTES.P2P_ORDERS_LIST, ROUTES.MY_ORDERS]) ? "active" : ""
                }
              >
                <P2pIcon />
                P2P Orders
              </NavLink> */}
            {/* </li> */}
            {/* <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("ORDERS", e)}
                to={ROUTES.ORDERS_OPENED}
                className={IncludesPath(ROUTES.ORDERS) ? "active" : ""}
              >
                <TransactionsIcon />
                Trade Desk
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("INVESTMENTS", e)}
                to={ROUTES.INVESTMENTS}
                disabled={true}
              >
                <InvestmentIcon />
                Vault
              </NavLink>
            </li> */}

            {/* <li className={styles.cryptoIcon}>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("CRYPTOWALLET", e)}
                to={ROUTES.ALL_COINS}
                className={IncludesPath(ROUTES.ALL_COINS) ? "active" : ""}
              >
                <CryptoWalletIcon />
                Crypto Wallet
              </NavLink>
            </li> */}
            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("REPORT", e)}
                to={ROUTES.REPORT}
                className={IncludesPath(ROUTES.REPORT) ? "active" : ""}
              >
                <ReportsIcon />
                Reports
              </NavLink>
            </li>
            {/* <li>
              <Link
                // onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                to={ROUTES.VERIFY_KYC}
              // className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
              >
                <SettingIcon />
                Kyc
              </Link>
            </li> */}
            <li>
              <NavLink
                onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                to={ROUTES.MY_PROFILE}
                className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
              >
                <SettingIcon />
                Settings
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                onClick={(e) => {
                  e.preventDefault();
                  if (kycStatus === "APPROVED") {
                    setShowCoinProfile(true);
                  }
                }}
                to={"/no-routes"}
              >
                <TransactionsIcon />
                Coin Profile
              </NavLink>
            </li> */}
          </ul>
        ) : (
          <ul>
            <li>
              <Link
                onClick={(e) => handleSidebarLinkClick("DASHBOARD", e)}
                className={IncludesPath(ROUTES.DASHBOARD) ? "active" : ""}
                to={ROUTES.VERIFY_KYC}
              >
                <DashboardIcon />
                Dashboard
              </Link>
            </li>

            <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <MarketplaceIcon />
                Marketplace
              </Link>
            </li>
            <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <MarketplaceIcon />
                Buy Equity
              </Link>
            </li>
            <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <WalletIcon />
                Wallet
              </Link>
            </li>
            <li>
              <Link
                to={ROUTES.VERIFY_KYC}
                className={IncludesPath(ROUTES.TRANSACTIONS) ? "active" : ""}
              >
                <TransactionsIcon />
                Transactions
              </Link>
            </li>
            {showStblMoneyNav && (
              <li>
                <Link to={ROUTES.VERIFY_KYC}>
                  <MoneyIcon />
                  STBL Money
                </Link>
              </li>
            )}
            {/* <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <P2pIcon />
                P2P
              </Link>
            </li> */}
            {/* <li>
              <Link
                to={ROUTES.VERIFY_KYC}
                className={IncludesPath(ROUTES.ORDERS) ? "active" : ""}
              >
                <TransactionsIcon />
                Trade Desk
              </Link>
            </li> */}
            {/* <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <InvestmentIcon />
                Vault
              </Link>
            </li> */}
            {/* <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <WalletIcon />
                Wallet Portfolio
              </Link>
            </li> */}
            <li>
              <Link to={ROUTES.VERIFY_KYC}>
                <WalletIcon />
                Reports
              </Link>
            </li>
            <li>
              <Link
                // onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                to={ROUTES.VERIFY_KYC}
              // className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
              >
                <SettingIcon />
                KYC
              </Link>
            </li>
            <li>
              <Link
                // onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                to={ROUTES.MY_PROFILE}
              // className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
              >
                <SettingIcon />
                Settings
              </Link>
            </li>

            {/* <li>
              <NavLink
                onClick={(e) => {
                  e.preventDefault();
                  if (kycStatus === "APPROVED") {
                    setShowCoinProfile(true);
                  }
                }}
                to={"/no-routes"}
              >
                <TransactionsIcon />
                Coin Profile
              </NavLink>
            </li> */}
          </ul>
        )}

        <div className={styles.sidebar_footer}>
          {/* <hr className={styles.vertical_line} />
          {kycStatus === "APPROVED" ? (
            <ul>
              <li>
                <NavLink
                  onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                  to={ROUTES.MY_PROFILE}
                  className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
                >
                  <SettingIcon />
                  Settings
                </NavLink>
              </li>
              <li>
                <NavLink
                  onClick={(e) => handleSidebarLinkClick("HELP", e)}
                  to={ROUTES.HELP_FEATURE_1}
                  className={IncludesPath(ROUTES.HELP) ? "active" : ""}
                >
                  <HelpIcon />
                  Help
                </NavLink>
              </li>
            </ul>
          ) : (
            <ul>
              <li>
                <Link
                  onClick={(e) => handleSidebarLinkClick("SETTINGS", e)}
                  to={ROUTES.BUY}
                  // to={ROUTES.MY_PROFILE}
                  className={IncludesPath(ROUTES.SETTINGS) ? "active" : ""}
                >
                  <SettingIcon />
                  Settings
                </Link>
              </li>
              <li>
                <Link
                  onClick={(e) => handleSidebarLinkClick("HELP", e)}
                  to={ROUTES.BUY}
                  // to={ROUTES.HELP_FEATURE_1}
                  className={IncludesPath(ROUTES.HELP) ? "active" : ""}
                >
                  <HelpIcon />
                  Help
                </Link>
              </li>
            </ul>
          )} */}

          <ul>
            <li>
              <Button
                fluid
                className={styles.btn_logout}
                variant='darkblue_btn'
                onClick={() => {
                  setShowLog(true);
                  // handleClick();
                }}
              >
                <span className={"logout_icon"}>
                  <LogoutIcon />
                </span>
                Logout{" "}
              </Button>
            </li>
          </ul>
        </div>
      </aside >
      <CoinProfile
        show={showCoinProfile}
        handleClose={() => setShowCoinProfile(false)}
      />

      <LogoutModal show={showLog} handleClose={() => setShowLog(false)} />
    </>
  );
};

export default Sidebar;
